import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';

@Component({
  standalone:true,
  imports: [CommonModule],
  selector: 'app-confirmation-alert-input',
  templateUrl: './confirmation-alert-input.component.html',
  styleUrls: ['./confirmation-alert-input.component.scss']
})
export class ConfirmationAlertInputComponent implements OnInit, OnChanges {

  @ContentChild("fields")
  fields!: TemplateRef<any>;


  @Input() public showConfirmationModal: boolean = false;
  @Input() public confirmBtnEnabled: boolean = false;
  @Input() public modalTitle: string = '';

  @Input() public showCloseButton: boolean = false;
  @Input() public showCloseHeaderButton: boolean = false;
  @Input() public showCancelButton: boolean = false;
    @Input() public showSaveButton: boolean = false;

  @Output() modalConfirm = new EventEmitter<string>(true);
  @Output() modalCancel = new EventEmitter<string>(true);

  @ViewChild('confirmationInputModal') confirmationInputModal: any;

  @Input() public confirmationMessage: string = '';


  constructor() {

  }

  get context() {
    return this;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showConfirmationModal'] && changes['showConfirmationModal']?.previousValue != changes['showConfirmationModal']?.currentValue) {
      if (changes['showConfirmationModal']?.currentValue) {
        this.confirmationInputModal.nativeElement.classList.add('show');
        this.confirmationInputModal.nativeElement.classList.add('d-block');
      }
      else if (changes['showConfirmationModal'] && changes['showConfirmationModal'].currentValue === false) {
        if (this.confirmationInputModal) {
          this.confirmationInputModal.nativeElement.classList.remove('show');
          this.confirmationInputModal.nativeElement.classList.remove('d-block');
        }
      }
    }
  }


  modalClose() {
    this.confirmationInputModal.nativeElement.classList.remove('show');
    this.confirmationInputModal.nativeElement.classList.remove('d-block');
    if (this.modalCancel)
      this.modalCancel.emit();
  }

  modalConfirmClick() {
    if (this.modalConfirm)
      this.modalConfirm.emit();
  }

} 